import { RecoilRoot } from 'recoil'
import type { MutableSnapshot } from 'recoil'
import type { ReactNode } from 'react'
import { EditorProbeRecoilObserver } from '@/providers/EditorProbeRecoilObserver'

type Props = {
  children: ReactNode
  override?: boolean
  /**
   * Seeds the store before the first render, the way `RecoilRoot` takes it.
   * Already forwarded — `RecoilRoot` is typed `React.FC<RecoilRootProps>`,
   * which under React 18's types accepts no children of its own, so this is
   * the only way in for a caller that needs both.
   */
  initializeState?: (mutableSnapshot: MutableSnapshot) => void
}

export const RecoilProvider = ({ children, ...props }: Props) => {
  return (
    <RecoilRoot {...props}>
      <EditorProbeRecoilObserver />
      {children}
    </RecoilRoot>
  )
}

export default RecoilProvider
